import React, { useState, useCallback } from 'react'
import Menu from './Menu'
import ButtonWithMenu from '../ButtonWithMenu'

const LearnSection = ({ className }) => {
  const [open, setOpen] = useState(false)

  const handleCloseMenu = useCallback(() => {
    setOpen(false)
  }, [])
  return (
    <ButtonWithMenu
      css={className}
      open={open}
      setOpen={setOpen}
      overlay={<Menu onClose={handleCloseMenu} />}
    >
      Learn
    </ButtonWithMenu>
  )
}

export default LearnSection
